import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const useEmulators = import.meta.env.VITE_USE_EMULATORS === "true";

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;

// A production build MUST have the real Firebase web config baked in from
// portal/.env.production. If it's missing, the SDK would fall back to a bogus
// "demo" key and every sign-in fails with the cryptic
// "auth/api-key-not-valid". Fail loudly at startup so the build/deploy
// misconfiguration is obvious instead of silently shipping a broken portal.
if (import.meta.env.PROD && !useEmulators && !apiKey) {
  throw new Error(
    "Firebase web config missing: VITE_FIREBASE_API_KEY was empty at build time. " +
      "This portal bundle was built without portal/.env.production present — " +
      "rebuild with it in the build context.",
  );
}

export const app = initializeApp({
  apiKey: apiKey || "demo",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "demo-bundlestamp.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-bundlestamp",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "demo",
  // Enables Google Analytics (GA4). Left undefined in dev/emulator so analytics no-ops.
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || undefined,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const API_BASE: string = import.meta.env.VITE_API_BASE || "";
export const MEASUREMENT_ID: string = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "";
export const USE_EMULATORS = useEmulators;

if (useEmulators) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
}
